<template>
    <div :class="classes">
        <div class="card h-100 card-events">
            <a :href="url" :aria-labelledby="title_id" class="d-block aspect-ratio-box aspect-ratio-box-16x9">
                <img :src="featured_img" :alt="alt_text" class="aspect-ratio-box-inner object-fit-cover"/>
                <span v-if="is_past" class="event-past-label badge badge-dark">Past Event</span>
            </a>
            <div class="card-body px-0 pb-0 pt-2 mt-4">
                <a :href="url" :id="title_id" class="d-block h6 card-title mb-0">{{ title }}</a>
                <div class="card-link my-2">
                    <a v-if="location_title" :href="url" class="btn btn-dark">{{ location_title }}</a>
                </div>
                <p class="card-text mb-2 mb-0">{{ street_address }}</p>
                <div class="row event-datetime">
                  <div :class="time_display ? 'col-6' : 'col-12'">
                    <div class="event-date">
                      {{ date_display }}
                    </div>
                  </div>
                  <div v-if="time_display" class="col-6">
                    <div class="event-time">
                      {{ time_display }}
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'
    export default {
        props: ['event'],
        data() {
            return {
                id: 0,
                title: '',
                start_date: '',
                end_date: '',
                featured_img: '',
                registration_link: '',
                location_title: '',
                alt_text: '',
                street_address: '',
                time: '',
                classes: 'col-12 col-md-4 mb-3 card-wrap active',
                url: '',
                title_id: '',
                date_display: '',
                time_display: '',
            }
        },
        computed: {
            is_past() {
                return Date.now() > Date.parse(this.end_date)
            }
        },
        methods: {

            hidePost(){
                this.classes = 'col-12 col-md-4 mb-3 card-wrap'
            },
            renderPost(){
                this.id = this.$props.event['id']
                this.title = this.$props.event['title']
                this.start_date = this.$props.event['start_date']
                this.end_date = this.$props.event['end_date']
                this.featured_img = this.$props.event['featured_img']
                this.alt_text = this.$props.event['img_alt']
                this.registration_link = this.$props.event['registration_link']
                this.street_address = this.$props.event['street_address']
                this.location_title = this.$props.event['location_title']
                this.time = this.$props.event['time']
                this.url = this.$props.event['url']
                this.title_id = "event-" + this.id + "-title"
                this.date_display = this.$props.event['date_display']
                this.time_display = this.$props.event['time_display']
            }
        },
        mounted(){
            if(this.$store.state.results_count > this.$store.state.events_shown_count) {
                this.hidePost()
            }
            this.renderPost()
        }
    }
</script>
